export default __webpack_public_path__ + "static/media/640_portfolio03-jp-mobile.71ca21e7.png";